export default __webpack_public_path__ + "static/media/mconferences4.9b0b64d8.jpg";